import * as React from 'react';
import { ThemeContext } from 'styled-components';

import SVGIcon from '../../../Icon/SVGIcon';
import { useFocusControl } from '../../Utils';
import { useInputControlContext } from '../InputControl/InputControlContext';
import { useHoverContext } from '../Context/hoverContext';

import { ISelectInputProps } from './common';
import { SelectInputContainer, StyledSelectInput } from './SelectInputStyles';

export interface IInputSelectProps extends ISelectInputProps {
  selectId: string;
}

// exporting here is a work around for this issue https://github.com/microsoft/tslint-microsoft-contrib/issues/667
export const SelectInput =
  React.forwardRef<HTMLSelectElement, React.SelectHTMLAttributes<HTMLSelectElement> & IInputSelectProps>((
    props, ref
) => {
  const {
    children,
    inputProps,
    selectId,
  } = props;

  const { clickFocus, stopClickFocus, resetClickFocus } = useFocusControl();
  const defaultValue = inputProps && inputProps.defaultValue || '';
  const isDisabled = !!(inputProps && inputProps.disabled);
  const { themeTwo: { form: { select }}} = React.useContext(ThemeContext);
  const { isHovered, toggleHover } = useHoverContext();
  const toggleInputHover = isDisabled ? undefined : toggleHover ;
  const { error, ariaDescribedby } = useInputControlContext();
  const ariaDescribedbyWithInputProps = inputProps && inputProps['aria-describedby'] ?
    `${ariaDescribedby} ${inputProps['aria-describedby']}` : ariaDescribedby;

  return (
    <SelectInputContainer isHovered={isHovered} error={error}>
      <SVGIcon icon={select.icon.type} />

      <StyledSelectInput
        {...inputProps}
        aria-describedby={ariaDescribedbyWithInputProps ? ariaDescribedbyWithInputProps : undefined}
        as='select'
        defaultValue={(inputProps && inputProps.value) ? undefined : defaultValue}
        error={error}
        id={selectId}
        isHovered={isHovered}
        ref={ref}
        onBlur={resetClickFocus}
        onMouseDown={stopClickFocus}
        onMouseEnter={toggleInputHover}
        onMouseLeave={toggleInputHover}
        clickFocus={clickFocus}
      >
        {children}
      </StyledSelectInput>
    </SelectInputContainer>
  );
});

export default SelectInput;
